import { PreviewCart } from "../../components/cart/preview-cart";
import { ProductVariants } from "./product-variants";
import { PUB_SUB_EVENTS, publish } from "../../utils/pubsub";
class Product extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  // Called when element is inserted into DOM - SG 20260105
  connectedCallback() {
    // Restore size selection from sessionStorage on page load
    this.restoreSizeSelection();
  }

  // Restore size selection from sessionStorage if user navigated via colour swatch - SG 20260105
  restoreSizeSelection() {
    const storedSize = ProductVariants.getStoredSize();
    if (!storedSize) return;

    // Find all variant inputs and their labels
    const variantInputs = this.querySelectorAll<HTMLInputElement>(
      'product-variants input[type="radio"]'
    );

    // Collect ALL matching inputs (multiple product-variants elements exist for desktop/mobile)
    const matchingInputs: HTMLInputElement[] = [];
    const storedSizeClean = storedSize.replace(/\s+/g, ' ').trim();

    variantInputs.forEach((input) => {
      const label = this.querySelector<HTMLElement>(
        `label[for="${input.id}"] .size-text`
      );
      // Get text content and clean it (remove line breaks from split_title)
      const sizeText = label?.textContent?.replace(/\s+/g, ' ').trim() || '';
      const isAvailable = input.dataset.available === 'true';
      
      // Check if this matches stored size
      if (sizeText === storedSizeClean && isAvailable) {
        matchingInputs.push(input);
      }
    });

    // Select ALL matching variants (syncs desktop and mobile views) - SG 20260105
    matchingInputs.forEach((input, index) => {
      if (!input.checked) {
        input.checked = true;
        // Only trigger change on first one to avoid duplicate events
        if (index === 0) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  bindEvents() {
    const enplHeadingEle = this.querySelector(".product__enpl-heading");
    enplHeadingEle?.addEventListener("click", this.toggleEnplSection.bind(this));

    const descriptionHeadingEle = this.querySelectorAll(".product__description-heading");
    descriptionHeadingEle.forEach((ele) => {
      ele.addEventListener("click", this.toggleDescription.bind(this));
    });
    
    const fabricTabs = this.querySelectorAll(".fabric-tab");
    const swatchGroups = this.querySelectorAll(".fabric-swatch-group");
    
    fabricTabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        
        // Get the fabric slug from the clicked tab
        const fabricSlug = tab.getAttribute("data-fabric");
        
        // Remove active class from all tabs
        fabricTabs.forEach((t) => t.classList.remove("active"));
        
        // Add active class to clicked tab
        tab.classList.add("active");

        const activeTab = document.querySelector('.fabric-tab.active');
        if (activeTab){
          activeTab.scrollIntoView({
            behavior: 'smooth', 
            inline: 'center',
            block: 'nearest'
          })
        }
        
        // Hide all swatch groups
        swatchGroups.forEach((group) => group.classList.add("hidden"));
        
        // Show the corresponding swatch group
        if (fabricSlug) {
          const targetGroup = this.querySelector(`.fabric-swatch-group[data-fabric="${fabricSlug}"]`);
          if (targetGroup) {
            targetGroup.classList.remove("hidden");
          }
        }
      });
    });

    const addToCartButton = this.querySelector("cta-cart");
    if (addToCartButton?.classList.contains("disabled")) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }

    if (this.classList.contains("main-product-bundle")) {
      addToCartButton?.addEventListener("click", (event) => {
        this.addBundleProductsToCart(event);
      });
    } else {
      addToCartButton?.addEventListener("click", this.addProductToCart.bind(this));
    }

    // Size swatches are in product__size-swatches-group, not product__swatches-group - SG 20260105
    const productVariantInputs = this.querySelectorAll("product-variants input[type='radio']");
    const productVariants = new ProductVariants();
    productVariantInputs.forEach((input) => {
      const variantId = input.getAttribute("data-id") as string;

      input.addEventListener("change", () => {
        productVariants.onVariantSelect(variantId, this);
      });
    });
  }

  toggleEnplSection(event: Event) {
    const showMoreEle = this.querySelector(".show-more");
    const showLessEle = this.querySelector(".show-less");
    showMoreEle?.classList.toggle("hide");
    showLessEle?.classList.toggle("hide");

    const target = event.currentTarget as HTMLElement;
    target?.parentElement?.classList.toggle("is-open");
  }

  toggleDescription(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const parentEle = target?.parentElement;
    parentEle?.classList.toggle("active");
  }


  addBundleProductsToCart(event: any) {
    let productsArr: any = [];

    const bundleProducts = this.querySelectorAll(".product__bundle .product__bundle-product");
    const ctaButton = document.querySelector(".main-product .product__cart-cta");
    const ctaButtonLoader = ctaButton?.querySelector(".loading__spinner");

    let parentProductId = "";
    let parentProductName = "";
    let parentProductUrl = "";
    let parentproductPrice = "";
    let bundleProductCount = "";
    let parentProductCategory = "";
    let parentProductPrice = "";
    let parentProductQuantity = 0;

    const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
    const quantity = Number(quantityInput.value);

    if (ctaButton?.classList.contains("disabled")) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }

    try {
      const cta = event.currentTarget.parentElement;
      parentProductId = cta.getAttribute("data-bundle-product-id");
      parentProductName = cta.getAttribute("data-bundle-product-title");
      parentProductUrl = cta.getAttribute("data-bundle-product-url");
      parentProductId = cta.getAttribute("data-bundle-product-id") + Date.now();
      parentproductPrice = cta.getAttribute("data-bundle-product-price");
      bundleProductCount = cta.getAttribute("data-bundle-product-count");
      parentProductCategory = cta.getAttribute("data-bundle-product-category");
      parentProductPrice = cta.getAttribute("data-bundle-product-price");
      parentProductQuantity = quantity;
    } catch {
      console.warn("Failed to fetch the product info from the parent of the CTA element.");
    }

    const quantityMap = new Array(quantity).fill(" ");
    quantityMap.forEach((qm, i) => {
      const now = new Date();
      const uniqueId = `${bundleProducts.length}--${now.getTime() + i}-${now.toISOString().slice(0, 9)}`;
      bundleProducts.forEach((product, productIndex) => {
        const variantInput =
          (product.querySelector('input[data-variant-defined="true"]') as HTMLInputElement) ||
          (product.querySelector('product-variants input[type="radio"]:checked') as HTMLInputElement) ||
          (product.querySelector('.product__no-variants input[type="radio"]:checked') as HTMLInputElement);
        const itemKey = variantInput.value;
        
        // Get the quantity required for this product in the bundle
        const bundleQuantity = Number(product.getAttribute("data-bundle-quantity")) || 1;
  
        productsArr.push({
          id: itemKey,
          quantity: bundleQuantity,
          properties: {
            Bundle: parentProductCategory || "",
            _bundleMatcher: uniqueId,
            _bundleId: uniqueId || "",
            _bundleCategory: parentProductCategory || "",
            _bundleTargetPrice: parentproductPrice,
            _bundlePrice: parentProductPrice || "",
            _bundleQuantity: bundleQuantity || "",
            _bundleProductCount: bundleProductCount,
            _bundleName: parentProductName || "",
            _bundleItemIndex: productIndex,
            // "product bundle url": parentProductUrl || ''
          },
        });
      });
    });

    const previewCart = new PreviewCart();

    productsArr.reverse();

    previewCart
      .addItems(productsArr)
      .then((data: any) => {
        if (data.status && data.status >= 400) {
          previewCart.closePreviewCart();

          let message = "There was an issue adding this item to your cart.";
          if (typeof data.description === "string") {
            message = data.description;
          } else {
            if (typeof data.description === "object") {
              const keys = Object.keys(data.description);
              if (keys.length && data.description[keys[0]].length) {
                message = data.description[keys[0]][0];
              }
            }
          }

          previewCart.cartErrorHandling(this.querySelector(".product-form__error-message-wrapper"), message);
        } else {
          if (parentProductPrice) {
            parentProductPrice = (Number.parseFloat(parentProductPrice) / 100).toFixed(2);
          } else {
            parentProductPrice = "0.00";
          }
          try {
            (window as any).dataLayer.push({
              event: "bundle_add_to_cart",
              name: parentProductName,
              product_id: parentProductId,
              category: parentProductCategory,
              price: parentProductPrice,
              quantity: quantity,
            });
          } catch {
            console.error("Failed to push product data to GA4 when adding blundle to cart");
          }

          // Hardcoded timeout - roughly determined by the time it takes for fastbundles to update the cart
          setTimeout(() => {
            previewCart.updateCartHTML();
          }, 2500);
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  }

  addProductToCart() {
    const variantInput =
      (this.querySelector('product-variants input[type="radio"]:checked') as HTMLInputElement) ||
      (this.querySelector('.product__no-variants input[type="radio"]:checked') as HTMLInputElement);

    const itemKey = variantInput?.value;
    const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
    const quantity = Number(quantityInput.value);

    // Get gift card checkbox status
    const giftCardCheckbox = this.querySelector(
      'input[name="properties[__shopify_send_gift_card_to_recipient]"]'
    ) as HTMLInputElement;
    let properties = {};

    // If gift card checkbox is checked, collect all recipient form data
    if (giftCardCheckbox && giftCardCheckbox.checked) {
      const recipientEmail = this.querySelector('input[name="properties[Recipient email]"]') as HTMLInputElement;
      const recipientName = this.querySelector('input[name="properties[Recipient name]"]') as HTMLInputElement;
      const message = this.querySelector('textarea[name="properties[Message]"]') as HTMLInputElement;
      const sendDate = this.querySelector('input[name="properties[Send on]"]') as HTMLInputElement;
      const timezoneOffset = this.querySelector('input[name="properties[__shopify_offset]"]') as HTMLInputElement;

      properties = {
        "Recipient email": recipientEmail?.value || "",
        "Recipient name": recipientName?.value || "",
        Message: message?.value || "",
        "Send on": sendDate?.value || "",
        __shopify_offset: timezoneOffset?.value || "",
        __shopify_send_gift_card_to_recipient: "on",
      };
    }

    const previewCart = new PreviewCart();

    previewCart
      .addItem(itemKey, quantity, properties)
      .then((data: any) => {
        if (data.status && data.status >= 400) {
          previewCart.closePreviewCart();

          let message = "There was an issue adding this item to your cart.";
          if (typeof data.description === "string") {
            message = data.description;
          } else {
            if (typeof data.description === "object") {
              const keys = Object.keys(data.description);
              if (keys.length && data.description[keys[0]].length) {
                message = data.description[keys[0]][0];
              }
            }
          }

          previewCart.cartErrorHandling(this.querySelector(".product-form__error-message-wrapper"), message);
        } else {
          previewCart.refreshPreviewCart(data);
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  }
}

customElements.define("main-product", Product);
